// CSS Modules - component class name: NaviSelectCascading__

<template>
  <div class="columns">
    <div
      :class="[
        $style.cascading,
        $style.container,
        'column is-half-tablet is-half-desktop'
      ]"
      @mouseenter="mouseenterEvent(0)"
      @mouseleave="mouseleaveEvent(0), mouseleaveEvent(1)"
      @click="clickEvent(0)"
    >
      <a
        :class="[
          {
            [$style.blue]: config.colour === 'blue',
            [$style.white]: config.colour === 'white',
            [$style.orange]: config.colour === 'orange',
            [$style.noHover]: noHover[0],
            [$style.open]: open[0]
          },
          $style.select
        ]"
      >
        <span v-if="selectedEntry && entry" v-html="entry.label"></span>
        <span v-else v-html="config.defaultLabel" />
        <span :class="$style.triangle"></span>
      </a>
      <ul>
        <li
          v-for="(entry, index) in config.entries"
          :key="index"
          :value="index"
          :id="`entry${index}`"
          :class="{
            [$style.active]: index === selectedEntry
          }"
        >
          <a v-if="entry.url" :href="entry.url">
            <span v-html="entry.label" />
          </a>
          <a v-else @click="selectEntry(index)"><span v-html="entry.label"/></a>
        </li>
      </ul>
    </div>
    <div
      v-if="config.cascading && children && Object.keys(children).length"
      :class="[$style.cascading, $style.container, 'column is-half']"
      @mouseenter="mouseenterEvent(1)"
      @mouseleave="mouseleaveEvent(1)"
      @click="clickEvent(1)"
    >
      <a
        :class="[
          {
            [$style.blue]: config.colour === 'blue',
            [$style.white]: config.colour === 'white',
            [$style.orange]: config.colour === 'orange',
            [$style.noHover]: noHover[1],
            [$style.open]: open[1]
          },
          $style.select
        ]"
      >
        <span
          v-if="selectedChild && children[selectedChild]"
          v-html="children[selectedChild].label"
        />
        <span v-else v-html="config.defaultLabel" />
        <span :class="$style.triangle"></span>
      </a>
      <ul>
        <li
          v-for="(child, index) in children"
          :key="JSON.stringify(child)"
          :class="{
            [$style.active]: index === selectedChild
          }"
        >
          <a v-if="child.url" :href="child.url"><span v-html="child.label"/></a>
          <a v-else v-html="child.label">
            <span v-html="child.label" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "NaviSelectCascading",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      open: [false, false],
      noHover: [false, false],
      entry: null,
      children: [],
      selectedEntry: null,
      selectedChild: null
    };
  },
  methods: {
    clickEvent(number) {
      this.$set(this.open, number, true);
    },
    mouseenterEvent(number) {
      this.$set(this.noHover, number, true);
    },
    mouseleaveEvent(number) {
      setTimeout(() => {
        this.$set(this.open, number, false);
        this.$set(this.noHover, number, false);
      }, 1000);
    },
    setInitialSelectedChild() {
      if (this.config.selectedChild) {
        this.selectedChild = this.config.selectedChild;
      } else {
        this.getSelectedChildFromUrl();
      }
    },
    getSelectedChildFromUrl() {
      const params = window.location.search.substr(1).split("&");
      const naviSelectedParam = params.find(param =>
        param.includes("naviSelectedChild")
      );
      const naviSelectedParamValue = naviSelectedParam
        ? naviSelectedParam.split("=")[1]
        : null;
      const isChildAvailable =
        this.children && this.children[naviSelectedParamValue];
      this.selectedChild = isChildAvailable ? naviSelectedParamValue : null;
    },
    selectEntry(entryId) {
      let isClicked = !!entryId;
      let id = entryId || this.config.selectedEntry;

      // Populate list of children in the second dropdown
      if (id !== null) {
        this.entry = this.config.entries[id] || null;
        this.selectedEntry = id;
        this.children =
          this.entry && this.entry.children ? this.entry.children : [];

        if (isClicked) {
          this.selectedChild = null;
          this.clickEvent(1);
          this.mouseenterEvent(1);
        } else {
          this.setInitialSelectedChild();
        }
      }
    }
  },
  mounted() {
    this.selectEntry();
  }
};
</script>

<style module lang="scss">
@import "./NaviSelectCascading.scss";
</style>
